import { createAction, props } from '@ngrx/store';

export const setTransactionResults = createAction(
  '[Transaction] Set Result',
  props<{ transactionResults: any }>(),
);
export const setTransactionValidateTransaction = createAction(
  '[Transaction] Set Validate Transaction',
  props<{ transactionValidateTransaction: any }>(),
);
export const setTransactionStartDate = createAction(
  '[Transaction] Set Start Date',
  props<{ transactionStartDate: any }>(),
);
export const setTransactionEndDate = createAction(
  '[Transaction] Set End Date',
  props<{ transactionEndDate: any }>(),
);
export const setTransactionPage = createAction(
  '[Transaction] Set Page',
  props<{ transactionPage: any }>(),
);
